import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/images/logo1.png'


const _hoisted_1 = {
  key: 0,
  class: "refereeeIntro"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" Logezy Reference ")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "content"
}
const _hoisted_4 = { class: "texts" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" has requested an employment reference via Logezy Reference for ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(", who claims to have worked between ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" and ")
const _hoisted_8 = { class: "complete-btn" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Complete Reference ")
const _hoisted_10 = {
  key: 1,
  class: "refereeDetails"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Complete")
const _hoisted_12 = { class: "refereePage1" }
const _hoisted_13 = {
  key: 0,
  class: "title"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Please confirm the reference details below are correct for   ")
const _hoisted_15 = {
  key: 1,
  class: "title"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "subline" }, null, -1)
const _hoisted_17 = { class: "referePInfo" }
const _hoisted_18 = { class: "formContent" }
const _hoisted_19 = { class: "overflowDiv" }
const _hoisted_20 = {
  key: 1,
  class: "viewfields"
}
const _hoisted_21 = {
  key: 1,
  class: "viewfields"
}
const _hoisted_22 = {
  key: 1,
  class: "viewfields"
}
const _hoisted_23 = {
  key: 1,
  class: "viewfields"
}
const _hoisted_24 = {
  key: 1,
  class: "viewfields"
}
const _hoisted_25 = {
  key: 1,
  class: "viewfields"
}
const _hoisted_26 = { class: "dateSec" }
const _hoisted_27 = {
  key: 1,
  class: "ddate"
}
const _hoisted_28 = { class: "dateSec" }
const _hoisted_29 = {
  key: 1,
  class: "ddate"
}
const _hoisted_30 = {
  key: 0,
  class: "footersec"
}
const _hoisted_31 = {
  key: 0,
  style: {"width":"100%","display":"flex","justify-content":"center"}
}
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Edit this details")
const _hoisted_33 = {
  key: 1,
  style: {"width":"100%"},
  class: "edittbns"
}
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Save")
const _hoisted_36 = { class: "additionalDetails" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h2", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" Please complete the following details about   "),
  /*#__PURE__*/_createElementVNode("span", null, "yourself")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "subline" }, null, -1)
const _hoisted_39 = { class: "footersec" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Save Details")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Complete")
const _hoisted_42 = { class: "refereePage2" }
const _hoisted_43 = { class: "title" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Please complete the following details about   ")
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "subline" }, null, -1)
const _hoisted_46 = { class: "qprofile" }
const _hoisted_47 = {
  key: 0,
  class: "dynmicForm"
}
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { class: "Qnumber" }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { class: "Qnumber" }
const _hoisted_52 = { key: 2 }
const _hoisted_53 = { class: "Qnumber" }
const _hoisted_54 = { key: 3 }
const _hoisted_55 = { class: "Qnumber" }
const _hoisted_56 = { key: 4 }
const _hoisted_57 = { class: "Qnumber" }
const _hoisted_58 = { key: 5 }
const _hoisted_59 = { class: "Qnumber" }
const _hoisted_60 = { key: 6 }
const _hoisted_61 = { class: "Qnumber" }
const _hoisted_62 = { key: 7 }
const _hoisted_63 = { class: "Qnumber" }
const _hoisted_64 = { class: "footersec" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode("Save Details")
const _hoisted_66 = { class: "refereePage3" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("h3", null, "Thank you for providing your references", -1)
const _hoisted_68 = { class: "footersec" }
const _hoisted_69 = /*#__PURE__*/_createTextVNode("You may close this window when finished.")
const _hoisted_70 = {
  key: 1,
  class: "refereeeIntro"
}
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" Logezy Reference ")
], -1)
const _hoisted_72 = { class: "content" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", {
  class: "texts",
  style: {"text-align":"center"}
}, " You have already submitted the reference ", -1)
const _hoisted_74 = { class: "complete-btn" }
const _hoisted_75 = /*#__PURE__*/_createTextVNode(" You may close this window ")
const _hoisted_76 = {
  key: 2,
  class: "refereeeIntro"
}
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" Logezy Reference ")
], -1)
const _hoisted_78 = { class: "content" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", {
  class: "texts",
  style: {"text-align":"center"}
}, " The page is expired! ", -1)
const _hoisted_80 = { class: "complete-btn" }
const _hoisted_81 = /*#__PURE__*/_createTextVNode(" You may close this window ")
const _hoisted_82 = {
  key: 0,
  class: "spinners"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_CheckCircleFilled = _resolveComponent("CheckCircleFilled")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_month_picker = _resolveComponent("a-month-picker")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_rate = _resolveComponent("a-rate")!
  const _component_HeartOutlined = _resolveComponent("HeartOutlined")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          sm: 24,
          md: 20,
          lg: 16,
          xl: 12,
          style: {"margin":"auto"}
        }, {
          default: _withCtx(() => [
            (_ctx.pageLoaded && _ctx.showForm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _hoisted_2,
                  (_ctx.introPage === true && _ctx.openedFrom === 'refereePage')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("h2", null, "Hi " + _toDisplayString(_ctx.refereDetails.referee_name) + ",", 1),
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.refereDetails.candidate.agency_name), 1),
                          _hoisted_5,
                          _createElementVNode("span", null, _toDisplayString(_ctx.refereDetails.candidate.candidate_name), 1),
                          _hoisted_6,
                          _createElementVNode("span", null, _toDisplayString(_ctx.moment(_ctx.refereDetails.work_start, "YYYY-MM-DD").format(
                  "MMMM YYYY"
                )), 1),
                          _hoisted_7,
                          _createElementVNode("span", null, _toDisplayString(_ctx.moment(_ctx.refereDetails.work_end, "YYYY-MM-DD").format("MMMM YYYY")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            size: "large",
                            block: "",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.completeReference()))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_9
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.introPage === false && _ctx.showForm)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_a_collapse, {
                          activeKey: _ctx.activeKey,
                          "onUpdate:activeKey": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.activeKey) = $event)),
                          accordion: "",
                          onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.tabChanged(_ctx.activeKey)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_collapse_panel, {
                              key: "1",
                              header: "reference details",
                              class: _normalizeClass(["firstheader", _ctx.questionPage === true ? 'showfirstheader' : ''])
                            }, {
                              extra: _withCtx(() => [
                                _createVNode(_component_CheckCircleFilled),
                                _hoisted_11
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_12, [
                                  (_ctx.openedFrom === 'refereePage')
                                    ? (_openBlock(), _createElementBlock("h2", _hoisted_13, [
                                        _hoisted_14,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.refereDetails?.referee_name), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("h2", _hoisted_15, " Please add the reference details. ")),
                                  _hoisted_16,
                                  _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("div", _hoisted_18, [
                                      _createVNode(_component_a_form, {
                                        ref: "refereePersonalFormRef",
                                        model: _ctx.refereePersonalModal,
                                        rules: _ctx.refereePersonalRules,
                                        "label-col": _ctx.labelCol,
                                        "wrapper-col": _ctx.wrapperCol
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_19, [
                                            _createVNode(_component_a_form_item, {
                                              label: "Your First Name",
                                              required: "",
                                              name: "first_name"
                                            }, {
                                              default: _withCtx(() => [
                                                (_ctx.editRefereeDetails)
                                                  ? (_openBlock(), _createBlock(_component_a_input, {
                                                      key: 0,
                                                      value: _ctx.refereePersonalModal.first_name,
                                                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.refereePersonalModal.first_name) = $event)),
                                                      type: "text",
                                                      placeholder: "",
                                                      "allow-clear": "",
                                                      autocomplete: "off"
                                                    }, null, 8, ["value"]))
                                                  : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.refereePersonalModal.first_name), 1))
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_a_form_item, {
                                              label: "Your Last Name",
                                              required: "",
                                              name: "last_name"
                                            }, {
                                              default: _withCtx(() => [
                                                (_ctx.editRefereeDetails)
                                                  ? (_openBlock(), _createBlock(_component_a_input, {
                                                      key: 0,
                                                      value: _ctx.refereePersonalModal.last_name,
                                                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.refereePersonalModal.last_name) = $event)),
                                                      type: "text",
                                                      placeholder: "",
                                                      "allow-clear": "",
                                                      autocomplete: "off"
                                                    }, null, 8, ["value"]))
                                                  : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.refereePersonalModal.last_name), 1))
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_a_form_item, {
                                              label: "Company name",
                                              required: "",
                                              name: "company"
                                            }, {
                                              default: _withCtx(() => [
                                                (_ctx.editRefereeDetails)
                                                  ? (_openBlock(), _createBlock(_component_a_input, {
                                                      key: 0,
                                                      value: _ctx.refereePersonalModal.company,
                                                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.refereePersonalModal.company) = $event)),
                                                      type: "text",
                                                      placeholder: "",
                                                      "allow-clear": "",
                                                      autocomplete: "off"
                                                    }, null, 8, ["value"]))
                                                  : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.refereePersonalModal.company), 1))
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_a_form_item, {
                                              ref: "email",
                                              required: "",
                                              label: "Email",
                                              name: "email"
                                            }, {
                                              default: _withCtx(() => [
                                                (_ctx.editRefereeDetails)
                                                  ? (_openBlock(), _createBlock(_component_a_input, {
                                                      key: 0,
                                                      placeholder: "",
                                                      value: _ctx.refereePersonalModal.email,
                                                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.refereePersonalModal.email) = $event)),
                                                      type: "text",
                                                      "allow-clear": "",
                                                      autocomplete: "off"
                                                    }, null, 8, ["value"]))
                                                  : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.refereePersonalModal.email), 1))
                                              ]),
                                              _: 1
                                            }, 512),
                                            (_ctx.openedFrom === 'refereePage')
                                              ? (_openBlock(), _createBlock(_component_a_form_item, {
                                                  key: 0,
                                                  label: ' ' +
                            _ctx.refereDetails?.candidate.candidate_name +
                            '  Job Title',
                                                  required: "",
                                                  name: "candidate_job"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.editRefereeDetails)
                                                      ? (_openBlock(), _createBlock(_component_a_input, {
                                                          key: 0,
                                                          value: _ctx.refereePersonalModal.candidate_job,
                                                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.refereePersonalModal.candidate_job) = $event)),
                                                          type: "text",
                                                          placeholder: "",
                                                          "allow-clear": "",
                                                          autocomplete: "off"
                                                        }, null, 8, ["value"]))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.refereePersonalModal.candidate_job), 1))
                                                  ]),
                                                  _: 1
                                                }, 8, ["label"]))
                                              : (_openBlock(), _createBlock(_component_a_form_item, {
                                                  key: 1,
                                                  label: ' ' +
                            _ctx.candidateDetails.candidate_name +
                            '  Job Title',
                                                  required: "",
                                                  name: "candidate_job"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.editRefereeDetails)
                                                      ? (_openBlock(), _createBlock(_component_a_input, {
                                                          key: 0,
                                                          value: _ctx.refereePersonalModal.candidate_job,
                                                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.refereePersonalModal.candidate_job) = $event)),
                                                          type: "text",
                                                          placeholder: "",
                                                          "allow-clear": "",
                                                          autocomplete: "off"
                                                        }, null, 8, ["value"]))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.refereePersonalModal.candidate_job), 1))
                                                  ]),
                                                  _: 1
                                                }, 8, ["label"])),
                                            _createElementVNode("div", _hoisted_26, [
                                              _createVNode(_component_a_form_item, {
                                                ref: "workstartmonth",
                                                required: "",
                                                label: "Candidate Employment Start Date",
                                                name: "workstartmonth",
                                                class: "dateSec1"
                                              }, {
                                                default: _withCtx(() => [
                                                  (_ctx.editRefereeDetails)
                                                    ? (_openBlock(), _createBlock(_component_a_month_picker, {
                                                        key: 0,
                                                        value: 
                                  _ctx.refereePersonalModal.workstartmonth
                                ,
                                                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((
                                  _ctx.refereePersonalModal.workstartmonth
                                ) = $event)),
                                                        "allow-clear": "",
                                                        placeholder: "Select month",
                                                        format: "MMMM"
                                                      }, null, 8, ["value"]))
                                                    : _createCommentVNode("", true),
                                                  (!_ctx.editRefereeDetails)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.moment(
                                    _ctx.refereePersonalModal.workstartmonth,
                                    "YYYY-MM-DD"
                                  ).format("MMMM")) + " " + _toDisplayString(_ctx.moment(
                                    _ctx.refereePersonalModal.workstartyear,
                                    "YYYY-MM-DD"
                                  ).format("YYYY")), 1))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              }, 512),
                                              (_ctx.editRefereeDetails)
                                                ? (_openBlock(), _createBlock(_component_a_form_item, {
                                                    key: 0,
                                                    ref: "workstartyear",
                                                    required: "",
                                                    name: "workstartyear",
                                                    class: "dateSec2"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_a_date_picker, {
                                                        value: 
                                  _ctx.refereePersonalModal.workstartyear
                                ,
                                                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((
                                  _ctx.refereePersonalModal.workstartyear
                                ) = $event)),
                                                        mode: "year",
                                                        "allow-clear": "",
                                                        format: "YYYY",
                                                        placeholder: "Select year",
                                                        onFocus: _ctx.getfocus1,
                                                        showToday: false,
                                                        open: _ctx.startYearOpen,
                                                        onPanelChange: _ctx.handlePanelChange1
                                                      }, null, 8, ["value", "onFocus", "open", "onPanelChange"])
                                                    ]),
                                                    _: 1
                                                  }, 512))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_28, [
                                              _createVNode(_component_a_form_item, {
                                                ref: "workendmonth",
                                                label: "Candidate Employment End Date :",
                                                name: "workendmonth",
                                                required: "",
                                                class: "dateSec1"
                                              }, {
                                                default: _withCtx(() => [
                                                  (_ctx.editRefereeDetails)
                                                    ? (_openBlock(), _createBlock(_component_a_month_picker, {
                                                        key: 0,
                                                        value: 
                                  _ctx.refereePersonalModal.workendmonth
                                ,
                                                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((
                                  _ctx.refereePersonalModal.workendmonth
                                ) = $event)),
                                                        "allow-clear": "",
                                                        placeholder: "Select month",
                                                        format: "MMMM"
                                                      }, null, 8, ["value"]))
                                                    : _createCommentVNode("", true),
                                                  (!_ctx.editRefereeDetails)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.moment(
                                    _ctx.refereePersonalModal.workendmonth,
                                    "YYYY-MM-DD"
                                  ).format("MMMM")) + " " + _toDisplayString(_ctx.moment(
                                    _ctx.refereePersonalModal.workendyear,
                                    "YYYY-MM-DD"
                                  ).format("YYYY")), 1))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              }, 512),
                                              (_ctx.editRefereeDetails)
                                                ? (_openBlock(), _createBlock(_component_a_form_item, {
                                                    key: 0,
                                                    ref: "workendyear",
                                                    name: "workendyear",
                                                    required: "",
                                                    class: "dateSec2"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_a_date_picker, {
                                                        value: _ctx.refereePersonalModal.workendyear,
                                                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.refereePersonalModal.workendyear) = $event)),
                                                        mode: "year",
                                                        "allow-clear": "",
                                                        placeholder: "Select year",
                                                        format: "YYYY",
                                                        onFocus: _ctx.getfocus2,
                                                        open: _ctx.endYearOpen,
                                                        onPanelChange: _ctx.handlePanelChange2
                                                      }, null, 8, ["value", "onFocus", "open", "onPanelChange"])
                                                    ]),
                                                    _: 1
                                                  }, 512))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]),
                                          (_ctx.openedFrom === 'refereePage')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                (!_ctx.editRefereeDetails)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                      _createVNode(_component_a_button, {
                                                        class: "editd",
                                                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.editRefereeDetailsInfo()))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _hoisted_32
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                (_ctx.editRefereeDetails)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                                      _createVNode(_component_a_button, {
                                                        class: "cancle",
                                                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.cancleRefereeDetails()))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _hoisted_34
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_a_button, {
                                                        class: "add",
                                                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.saveRefereeDetails()))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _hoisted_35
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      }, 8, ["model", "rules", "label-col", "wrapper-col"])
                                    ]),
                                    _createElementVNode("div", _hoisted_36, [
                                      _hoisted_37,
                                      _hoisted_38,
                                      _createVNode(_component_a_form, {
                                        ref: "refereeAdditionalFormRef",
                                        model: _ctx.refereeAdditionalModal,
                                        rules: _ctx.refereeAdditionalRules,
                                        layout: "vertical"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_form_item, {
                                            label: "What was your Job Title during their employment?",
                                            name: "job_title"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_input, {
                                                value: _ctx.refereeAdditionalModal.referee_job,
                                                "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.refereeAdditionalModal.referee_job) = $event)),
                                                type: "text",
                                                placeholder: "",
                                                "allow-clear": "",
                                                autocomplete: "off"
                                              }, null, 8, ["value"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_a_form_item, {
                                            label: "Please provide your contact number so we can confirm the legitimacy of this reference:",
                                            name: "phone"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_input, {
                                                value: _ctx.refereeAdditionalModal.phone,
                                                "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.refereeAdditionalModal.phone) = $event)),
                                                type: "text",
                                                placeholder: "",
                                                "allow-clear": "",
                                                autocomplete: "off"
                                              }, null, 8, ["value"])
                                            ]),
                                            _: 1
                                          }),
                                          (_ctx.openedFrom === 'refereePage')
                                            ? (_openBlock(), _createBlock(_component_a_form_item, {
                                                key: 0,
                                                ref: "referee_relationship",
                                                required: "",
                                                label: 
                            'Describe your relationship with  ' +
                            _ctx.refereDetails?.candidate.candidate_name +
                            '  I was/am their'
                          ,
                                                name: "referee_relationship"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_a_input, {
                                                    placeholder: "",
                                                    value: 
                              _ctx.refereeAdditionalModal.referee_relationship
                            ,
                                                    "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((
                              _ctx.refereeAdditionalModal.referee_relationship
                            ) = $event)),
                                                    type: "text",
                                                    "allow-clear": "",
                                                    autocomplete: "off"
                                                  }, null, 8, ["value"])
                                                ]),
                                                _: 1
                                              }, 8, ["label"]))
                                            : (_openBlock(), _createBlock(_component_a_form_item, {
                                                key: 1,
                                                ref: "referee_relationship",
                                                required: "",
                                                label: 
                            'Describe your relationship with  ' +
                            _ctx.candidateDetails.candidate_name +
                            '  I was/am their'
                          ,
                                                name: "referee_relationship"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_a_input, {
                                                    placeholder: "",
                                                    value: 
                              _ctx.refereeAdditionalModal.referee_relationship
                            ,
                                                    "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((
                              _ctx.refereeAdditionalModal.referee_relationship
                            ) = $event)),
                                                    type: "text",
                                                    "allow-clear": "",
                                                    autocomplete: "off"
                                                  }, null, 8, ["value"])
                                                ]),
                                                _: 1
                                              }, 8, ["label"]))
                                        ]),
                                        _: 1
                                      }, 8, ["model", "rules"]),
                                      _createElementVNode("div", _hoisted_39, [
                                        _createVNode(_component_a_button, {
                                          class: "add",
                                          loading: _ctx.saverefereLoading,
                                          onClick: _cache[18] || (_cache[18] = ($event: any) => (
                            _ctx.saveRefereeAdditionalDetails(_ctx.refereePersonalModal)
                          ))
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_40
                                          ]),
                                          _: 1
                                        }, 8, ["loading"])
                                      ])
                                    ])
                                  ])
                                ])
                              ]),
                              _: 1
                            }, 8, ["class"]),
                            (_ctx.questionPage)
                              ? (_openBlock(), _createBlock(_component_a_collapse_panel, {
                                  key: "2",
                                  header: 
                  'About  ' +
                  `${
                    _ctx.openedFrom === 'refereePage'
                      ? _ctx.refereDetails.candidate.candidate_name
                      : _ctx.candidateDetails.candidate_name
                  }`
                ,
                                  class: _normalizeClass(["secondheader", _ctx.thanksPage === true ? 'showsecondheader' : ''])
                                }, {
                                  extra: _withCtx(() => [
                                    _createVNode(_component_CheckCircleFilled),
                                    _hoisted_41
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_42, [
                                      _createElementVNode("h2", _hoisted_43, [
                                        _hoisted_44,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.openedFrom === "refereePage"
                        ? _ctx.refereDetails.candidate.candidate_name
                        : _ctx.candidateDetails.candidate_name), 1)
                                      ]),
                                      _hoisted_45,
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profiles, (profile, index) => {
                                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                                          _createElementVNode("div", _hoisted_46, [
                                            _createElementVNode("h2", null, _toDisplayString(profile.profile_name), 1)
                                          ]),
                                          (profile.questions)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                                _createVNode(_component_a_form, {
                                                  ref: "answerModalFormRef",
                                                  model: _ctx.answermodal,
                                                  layout: "vertical"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profile.questions, (question, index) => {
                                                      return (_openBlock(), _createElementBlock("div", {
                                                        key: question.id
                                                      }, [
                                                        (question.question_type === 'Short Text')
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                                              _createElementVNode("div", _hoisted_49, _toDisplayString(index + 1) + ".", 1),
                                                              _createVNode(_component_a_form_item, {
                                                                label: question.question,
                                                                name: "",
                                                                class: _normalizeClass(
                                question.is_required == 1 ? 'requiredF' : ''
                              )
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_a_input, {
                                                                    value: _ctx.answermodal[question.id],
                                                                    "onUpdate:value": ($event: any) => ((_ctx.answermodal[question.id]) = $event),
                                                                    type: "text",
                                                                    placeholder: "",
                                                                    "allow-clear": "",
                                                                    autocomplete: "off"
                                                                  }, null, 8, ["value", "onUpdate:value"])
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["label", "class"])
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (question.question_type === 'Long Text')
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                                              _createElementVNode("div", _hoisted_51, _toDisplayString(index + 1) + ".", 1),
                                                              _createVNode(_component_a_form_item, {
                                                                label: question.question,
                                                                name: "",
                                                                class: _normalizeClass(
                                question.is_required == 1 ? 'requiredF' : ''
                              )
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_a_textarea, {
                                                                    value: _ctx.answermodal[question.id],
                                                                    "onUpdate:value": ($event: any) => ((_ctx.answermodal[question.id]) = $event),
                                                                    rows: 4
                                                                  }, null, 8, ["value", "onUpdate:value"])
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["label", "class"])
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (question.question_type === 'Datepicker')
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                                              _createElementVNode("div", _hoisted_53, _toDisplayString(index + 1) + ".", 1),
                                                              _createVNode(_component_a_form_item, {
                                                                label: question.question,
                                                                name: "",
                                                                class: _normalizeClass(
                                question.is_required == 1 ? 'requiredF' : ''
                              )
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_a_date_picker, {
                                                                    value: _ctx.answermodal[question.id],
                                                                    "onUpdate:value": ($event: any) => ((_ctx.answermodal[question.id]) = $event),
                                                                    "allow-clear": "",
                                                                    format: "DD/MM/YYYY",
                                                                    showToday: false
                                                                  }, null, 8, ["value", "onUpdate:value"])
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["label", "class"])
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (question.question_type === 'Radio')
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                                              _createElementVNode("div", _hoisted_55, _toDisplayString(index + 1) + ".", 1),
                                                              _createVNode(_component_a_form_item, {
                                                                label: question.question,
                                                                name: "",
                                                                class: _normalizeClass(
                                question.is_required == 1 ? 'requiredF' : ''
                              )
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_a_radio_group, {
                                                                    value: _ctx.answermodal[question.id],
                                                                    "onUpdate:value": ($event: any) => ((_ctx.answermodal[question.id]) = $event)
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.options, (options) => {
                                                                        return (_openBlock(), _createBlock(_component_a_radio, {
                                                                          key: options.id,
                                                                          value: options.id
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(options.value), 1)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1032, ["value"]))
                                                                      }), 128))
                                                                    ]),
                                                                    _: 2
                                                                  }, 1032, ["value", "onUpdate:value"])
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["label", "class"])
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (question.question_type === 'Checkbox')
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                                              _createElementVNode("div", _hoisted_57, _toDisplayString(index + 1) + ".", 1),
                                                              _createVNode(_component_a_form_item, {
                                                                label: question.question,
                                                                name: "",
                                                                class: _normalizeClass(
                                question.is_required == 1 ? 'requiredF' : ''
                              )
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_a_checkbox_group, {
                                                                    value: _ctx.answermodal[question.id],
                                                                    "onUpdate:value": ($event: any) => ((_ctx.answermodal[question.id]) = $event)
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.options, (options) => {
                                                                        return (_openBlock(), _createBlock(_component_a_checkbox, {
                                                                          name: "type",
                                                                          key: options.id,
                                                                          value: options.id
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(options.value), 1)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1032, ["value"]))
                                                                      }), 128))
                                                                    ]),
                                                                    _: 2
                                                                  }, 1032, ["value", "onUpdate:value"])
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["label", "class"])
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (question.question_type === 'Number')
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                                              _createElementVNode("div", _hoisted_59, _toDisplayString(index + 1) + ".", 1),
                                                              _createVNode(_component_a_form_item, {
                                                                label: question.question,
                                                                name: "",
                                                                class: _normalizeClass(
                                question.is_required == 1 ? 'requiredF' : ''
                              )
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_a_input, {
                                                                    value: _ctx.answermodal[question.id],
                                                                    "onUpdate:value": ($event: any) => ((_ctx.answermodal[question.id]) = $event),
                                                                    type: "Number",
                                                                    placeholder: "",
                                                                    "allow-clear": "",
                                                                    autocomplete: "off",
                                                                    min: "1",
                                                                    oninput: "this.value = Math.abs(this.value)"
                                                                  }, null, 8, ["value", "onUpdate:value"])
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["label", "class"])
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (question.question_type === 'Dropdown')
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                                              _createElementVNode("div", _hoisted_61, _toDisplayString(index + 1) + ".", 1),
                                                              _createVNode(_component_a_form_item, {
                                                                label: question.question,
                                                                name: "",
                                                                class: _normalizeClass(
                                question.is_required == 1 ? 'requiredF' : ''
                              )
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_a_select, {
                                                                    value: _ctx.answermodal[question.id],
                                                                    "onUpdate:value": ($event: any) => ((_ctx.answermodal[question.id]) = $event),
                                                                    placeholder: ""
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.options, (options) => {
                                                                        return (_openBlock(), _createBlock(_component_a_select_option, {
                                                                          key: options.id,
                                                                          value: options.id
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(options.value), 1)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1032, ["value"]))
                                                                      }), 128))
                                                                    ]),
                                                                    _: 2
                                                                  }, 1032, ["value", "onUpdate:value"])
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["label", "class"])
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (question.question_type === 'Rating')
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                                              _createElementVNode("div", _hoisted_63, _toDisplayString(index + 1) + ".", 1),
                                                              _createVNode(_component_a_form_item, {
                                                                label: question.question,
                                                                name: "",
                                                                class: _normalizeClass(
                                question.is_required == 1 ? 'requiredF' : ''
                              )
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_a_rate, {
                                                                    value: _ctx.answermodal[question.id],
                                                                    "onUpdate:value": ($event: any) => ((_ctx.answermodal[question.id]) = $event),
                                                                    "allow-half": ""
                                                                  }, null, 8, ["value", "onUpdate:value"])
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["label", "class"])
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                                    }), 128))
                                                  ]),
                                                  _: 2
                                                }, 1032, ["model"])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128)),
                                      _createElementVNode("div", _hoisted_64, [
                                        _createVNode(_component_a_button, {
                                          class: "add",
                                          loading: _ctx.saveAnswerLoading,
                                          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.saveAnswers()))
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_65
                                          ]),
                                          _: 1
                                        }, 8, ["loading"])
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["header", "class"]))
                              : _createCommentVNode("", true),
                            (_ctx.thanksPage)
                              ? (_openBlock(), _createBlock(_component_a_collapse_panel, {
                                  key: "3",
                                  class: "thirdheader"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_66, [
                                      _createVNode(_component_HeartOutlined),
                                      _hoisted_67,
                                      _createElementVNode("div", _hoisted_68, [
                                        _createVNode(_component_a_button, {
                                          class: "add",
                                          onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.closewindow()))
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_69
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["activeKey"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.refereDetails && _ctx.openedFrom === 'refereePage')
              ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                  _hoisted_71,
                  _createElementVNode("div", _hoisted_72, [
                    _hoisted_73,
                    _createElementVNode("div", _hoisted_74, [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        size: "large",
                        block: "",
                        class: "closW",
                        onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.closewindow()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_75
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.showForm && _ctx.openedFrom === 'CandidaterefereePage')
              ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                  _hoisted_77,
                  _createElementVNode("div", _hoisted_78, [
                    _hoisted_79,
                    _createElementVNode("div", _hoisted_80, [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        size: "large",
                        block: "",
                        class: "closW",
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.closewindow()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_81
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.pageLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
          _createVNode(_component_a_spin)
        ]))
      : _createCommentVNode("", true)
  ]))
}